import { CaretRight } from 'phosphor-react'

import { colors, sizes } from '@motrix/tokens'

import { PhosphorIconProps } from './interfaces'

export const ArrowRight = ({
  color = colors.neutral09,
  size = '4',
  weight = 'regular',
}: PhosphorIconProps) => {
  return <CaretRight size={sizes[size]} weight={weight} color={color} />
}
